export const SECONDS = 'SECONDS';
export const MINUTES = 'MINUTES';
export const MILLI_SECONDS = 'MILLI_SECONDS';
export const ACTION_BY = Object.freeze({
  AUTOMATION: 'automation',
  EDIT: 'edit',
  REVIEW: 'review',
  POINTER: 'pointer',
  KEYBOARD: 'keyboard'
});
export const LOCK_ANNOTATION_ACTION = Object.freeze({
  LOCK: 'LOCK',
  UNLOCK: 'UNLOCK'
});
export const VISIBILITY_ANNOTATION_ACTION = Object.freeze({
  HIDE: 'HIDE',
  SHOW: 'SHOW'
});
export const NOTIFICATION_TYPE = Object.freeze({
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  INFO: 'INFO'
});
export const DISPLAY_ALL_ANNOTATIONS = 'displaying annotations from all the frames';
export const DISPLAY_CURRENT_FRAME_ANNOTATIONS = 'displaying annotations from current frame';
export const LOCK_ICON_SIZE = 16;
export const SHOW_HIDE_ICON_SIZE = 16;
export const EXPAND_COLLAPSE_ICON_SIZE = 24;
export const ANNOTATION_LABELS = 'annotationLabels';
export const RELATIONSHIP_GRAPH_RENDER_AREA_HEIGHT = '60vh';
const RELATIONSHIP_NODE_HEIGHT = 35;
export const RELATIONSHIP_TREE_ARROW = {
  VERTICAL_LINE: {
    LEFT_OFFSET: '0',
    TOP_OFFSET: String(RELATIONSHIP_NODE_HEIGHT),
    STROKE_WIDTH: '2px',
    DIMENSIONS: {
      x1: '0',
      y1: '5',
      x2: '0',
      lineHeight: 51.75,
      yOffset: 39.5
    }
  },
  HORIZONTAL_LINE: {
    LEFT_OFFSET: '-50px',
    TOP_OFFSET: String(RELATIONSHIP_NODE_HEIGHT / 2),
    WIDTH: '45px',
    HEIGHT: '10px',
    STROKE_WIDTH: '1px',
    DIMENSIONS: {
      x1: '0',
      y1: '5',
      x2: '43',
      y2: '5'
    }
  },
  STROKE_COLOR: '#d3d3d3',
  ARROW_END_ENHANCER: {
    points: '35,0 44,5 35,10'
  }
};
export const MAX_LABEL_COUNT_WARNING_MESSAGE = (title: string) => `Maximum count for ${title} reached. Please select another class.`;
export const MAX_LABEL_COUNT_ERROR_MESSAGE = (title: string) => `Maximum count for ${title} reached.`;
export const NO_SAM_REGION_DETECTED = `Auto-detection couldn't find any objects. Please draw manually or try a different area.`;
export const NO_SAM_REGION_DETECTED_FOR_CUSTOM_PROMPT = 'No objects found for the entered prompt. Please try a different prompt.';
export const NO_SAM_REGION_DETECTED_FOR_CLASS_PROMPT = 'No objects found for the selected class. Please try a custom prompt or draw manually.';
export const SAM_AUTO_DETECTION_FAILED = 'Auto-detection failed. Please try again.';
export const SAM_SEGMENTATION_REQUEST_FAILED = 'Segmentation failed. Please try again.';
export const MEDIA_NOT_LOADED_ERROR_MESSAGE = 'Please wait for media to load.';
export const LABELLING_TYPE = ({
  IMAGE: 'IMAGE',
  IMAGE_V1: 'IMAGE_V1',
  ENTITY_TAGGING: 'ENTITY_TAGGING',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  PDF: 'PDF',
  GEN_AI_LABELING: 'GEN_AI_LABELING',
  TEXT_LABELING: 'TEXT_LABELING',
  DATA_CLASSIFICATION: 'DATA_CLASSIFICATION',
  GENERATION: 'GENERATION',
  TRANSCRIPTION: 'TRANSCRIPTION'
} as const);
export const ULABEL_CONFIG = ({
  FRAUD_DETECTION: 'FRAUD_DETECTION',
  KWM_AUTH_PLUGIN_VERBOSE_LOGGING: 'KWM_AUTH_PLUGIN_VERBOSE_LOGGING',
  SIGNED_URL_TTL: 'SIGNED_URL_TTL',
  LEXICAL_EDITOR_ENABLED_AFTER_EPOCH: 'LEXICAL_EDITOR_ENABLED_AFTER_EPOCH',
  TRANSCRIPTION_INSTRUCTIONS: 'TRANSCRIPTION_INSTRUCTIONS',
  TRANSCRIPTION_REVIEW_INSTRUCTIONS: 'TRANSCRIPTION_REVIEW_INSTRUCTIONS'
} as const);
export const BUFFER_TIME_FOR_SIGNED_URL_REFRESH = 10 * 1000; // 10 seconds